import './Text.css'

export function Heading({ children, style = undefined, centered = false }) {
    return <h2 className={`heading ${centered && 'centered'}`} {...{ style }}>{children}</h2>
}

export function Subheading({ children, style = undefined }) {
    return <h3 className='subheading' {...{ style }}>{children}</h3>
}

export function Text({ children }) {
    return <p className='text'>{children}</p>
}